module.exports = __webpack_public_path__ + "static/media/Black_Medium.8dbc1ea5.webp";